export const createSiteForm = () => ({
  siteTypes: [],
  siteGroups: [],
  site: null,
})
